import { paths } from "@/paths";

export const dashboardConfig = {
	layout: "vertical",
	navColor: "evident",
	navItems: [
		{
			key: "wealth-insider",
			items: [
				{ key: "wi-overview", title: "Overview", href: paths.dashboard.wealthInsider.overview, icon: "chart-line-up" },
				{ key: "wi-reports", title: "Reports", href: paths.dashboard.wealthInsider.reports, icon: "read-cv-logo" },
				{ key: "wi-algorithms", title: "Algorithms", href: paths.dashboard.wealthInsider.algorithms, icon: "kanban" },
				{ key: "wi-universes", title: "Universes", href: paths.dashboard.wealthInsider.universes, icon: "globe-hemisphere-west" },
				{ key: "wi-schedules", title: "Schedules", href: paths.dashboard.wealthInsider.schedules, icon: "calendar-check" },
				{ key: "wi-activity", title: "Activity", href: paths.dashboard.wealthInsider.activity, icon: "align-left" },
			],
		},
	],
};
